import { render, staticRenderFns } from "./AgencesView.vue?vue&type=template&id=72938908"
import script from "./AgencesView.vue?vue&type=script&lang=js"
export * from "./AgencesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports